export const faqQueryKeys = {
  all: ["faq"] as const,
};
